// extracted by mini-css-extract-plugin
module.exports = {"dealContainer":"OTDealOption_dealContainer__2j4qt","buyVolume":"OTDealOption_buyVolume__2c61x"};